import { useEffect, useCallback, useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';

import { generateNonce, makeOAuthCookieNonce, makeOAuthState, Context } from '../utils/oauth';

export interface SocialLoginOptions {
  context: Context;
  googleRedirectUri?: string;
  onGoogleLoginClick: () => void;
}

const useSocialLogin = ({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onGoogleLoginClick = () => {},
  googleRedirectUri,
  context,
}: SocialLoginOptions) => {
  const [googleState, setGoogleState] = useState<string>();

  const login = useGoogleLogin({
    flow: 'auth-code',
    redirect_uri: googleRedirectUri,
    state: googleState,
    ux_mode: 'redirect',
  });
  const initiateGoogleLogin = useCallback(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    onGoogleLoginClick();
    const nonce = generateNonce();
    const cookie = makeOAuthCookieNonce({ url: window.location.href, nonce });
    document.cookie = cookie;
    setGoogleState(makeOAuthState({ context, provider: 'google', nonce }));
  }, [context, onGoogleLoginClick]);

  useEffect(() => {
    if (googleState) {
      login();
      setGoogleState(undefined);
    }
  }, [googleState, login]);

  return {
    googleLogin: initiateGoogleLogin,
  };
};

export default useSocialLogin;
